import { render, staticRenderFns } from "./UserGroupsTable.vue?vue&type=template&id=3cf633b6&scoped=true&"
import script from "./UserGroupsTable.vue?vue&type=script&lang=js&"
export * from "./UserGroupsTable.vue?vue&type=script&lang=js&"
import style0 from "./UserGroupsTable.vue?vue&type=style&index=0&id=3cf633b6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cf633b6",
  null
  
)

export default component.exports